import { Provider } from '@angular/core';
import { PurchaseOperationUnreconciledRepository } from '@domain/purchase-operation-unreconciled/repositories/purchase-operation-unreconciled.repository';
import { PurchaseOperationUnreconciledRepositoryService } from '../repositories/purchase-operation-unreconciled.service';

export const PurchaseOperationUnreconciledProvider: Provider[] = [
  {
    provide: PurchaseOperationUnreconciledRepository,
    useClass: PurchaseOperationUnreconciledRepositoryService,
  },
];
